import { Component, Input, OnInit } from '@angular/core';
import { ProfilesService } from 'src/app/_services/admin/profiles.service';

@Component({
    selector: 'app-config-section',
    templateUrl: './config-section.component.html',
    styleUrls: ['./config-section.component.scss'],
    standalone: false
})
export class ConfigSectionComponent implements OnInit {
  @Input() sections2: any = null;
  @Input() moduleName: string = '';
  zendeskToken: any = null;
  constructor(
    private profileService: ProfilesService,
  ) { }

  ngOnInit(): void {
  }
  getSettingRoute(route: string, inSetup: boolean): any[] {
    //Break the route string into segments
    const parts = route.split('/');

    const basePath = inSetup ? ['/dashboard', 'setup'] : ['/dashboard', this.moduleName];

    // Return the full router link array
    return [...basePath, ...parts].filter(part => part);;
  }

  public openItemToNewTab(url: any): void {

    window.open(url, "_blank", "noreferrer");
    // this.getZendeskTokenByCustellaToken(url) //Commented out to avoid redirecting to Zendesk
  }

  getZendeskTokenByCustellaToken(url: any) {
    this.profileService.getZendeskTokenByCustellaToken().subscribe((res: any) => {
      if (res.status == '200') {
        this.zendeskToken = res.body.id_token
        this.openZendesk(url)
      }
    })
  }
  openZendesk(urlZen: any) {
    let url = 'https://fieldex.zendesk.com/access/jwt?jwt=' + this.zendeskToken + "&return_to=" + urlZen;
    window.open(url, "_blank", "noreferrer");

  }
}
